import { WALLETINVOICEDETAILS } from '../actionTypes';

const initialState = {
  invoiceDetailsStatus: undefined,
  invoiceDetailsError: undefined,
  beneficiaryList: [],
  newBeneficiary: {},
  invoice: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case WALLETINVOICEDETAILS.FETCH:
      return {
        ...state,
        invoiceDetailsStatus: 'STARTED',
      };
    case WALLETINVOICEDETAILS.SUCCESS:
      return {
        ...state,
        invoice: action.payload,
        invoiceDetailsStatus: 'SUCCESS',
      };
    case WALLETINVOICEDETAILS.FAILED:
      return {
        ...state,
        invoiceDetailsError: action.payload,
        invoiceDetailsStatus: 'FAILED',
      };
    case WALLETINVOICEDETAILS.BENEFICIARY_SUCCESS:
      return {
        ...state,
        beneficiaryList: action.payload,
      };
    case WALLETINVOICEDETAILS.BENEFICIARY_ADD_SUCCESS:
      return {
        ...state,
        newBeneficiary: action.payload,
      };
    default:
      return state;
  }
};
